/** Debe coincidir con FinloopBackendCleanCode/domain/SigloPLD/SigloFixedProductCatalog.js */

// Productos ordenados: primero PLD/FT (alfabético), luego LFPIORPI (alfabético)
// CREDITO es el nombre canónico que Siglo reconoce — no usarlo directamente en la UI.
const SIGLO_PRODUCTS = Object.freeze([
  { label: 'ARRENDAMIENTO FINANCIERO', code: 'PLD / FT' },
  { label: 'CREDITO', code: 'PLD / FT' },
  { label: 'FIDEICOMISO', code: 'PLD / FT' },
  { label: 'ARRENDAMIENTO DE INMUEBLES', code: 'LFPIORPI' },
  { label: 'DONATIVOS', code: 'LFPIORPI' },
  { label: 'PRESTAMO', code: 'LFPIORPI' },
  { label: 'SERVICIOS DE COMERCIO EXTERNO', code: 'LFPIORPI' },
  { label: 'SERVICIOS PROFESIONALES', code: 'LFPIORPI' },
  { label: 'VENTA DE INMUEBLES', code: 'LFPIORPI' },
  { label: 'VENTA DE METALES Y JOYAS', code: 'LFPIORPI' },
  { label: 'VENTA DE OBRAS DE ARTE', code: 'LFPIORPI' },
  { label: 'VENTA DE VEHICULOS', code: 'LFPIORPI' },
]);

// Lista de productos para los dropdowns de la UI.
// CREDITO se expande en dos variantes visuales; ambas se normalizan a "CREDITO" al enviarse a Siglo.
const SIGLO_UI_PRODUCTS = Object.freeze([
  { label: 'ARRENDAMIENTO FINANCIERO', code: 'PLD / FT' },
  { label: 'CREDITO CUENTA CORRIENTE', code: 'PLD / FT', displayLabel: 'CRÉDITO CUENTA CORRIENTE (PLD / FT)' },
  { label: 'CREDITO SIMPLE', code: 'PLD / FT', displayLabel: 'CRÉDITO SIMPLE (PLD / FT)' },
  { label: 'FIDEICOMISO', code: 'PLD / FT' },
  { label: 'ARRENDAMIENTO DE INMUEBLES', code: 'LFPIORPI' },
  { label: 'DONATIVOS', code: 'LFPIORPI' },
  { label: 'PRESTAMO', code: 'LFPIORPI' },
  { label: 'SERVICIOS DE COMERCIO EXTERNO', code: 'LFPIORPI' },
  { label: 'SERVICIOS PROFESIONALES', code: 'LFPIORPI' },
  { label: 'VENTA DE INMUEBLES', code: 'LFPIORPI' },
  { label: 'VENTA DE METALES Y JOYAS', code: 'LFPIORPI' },
  { label: 'VENTA DE OBRAS DE ARTE', code: 'LFPIORPI' },
  { label: 'VENTA DE VEHICULOS', code: 'LFPIORPI' },
]);

// Todos los productos comparten los mismos 8 métodos de pago
const TX_ALL_METHODS = Object.freeze([
  'EFECTIVO',
  'DOCS. / VALORES',
  'TRANSFERENCIA',
  'DIVISAS',
  'CHEQUES',
  'ORO / PLATINO',
  'PLATA AMONEDADA',
  'CHEQUES DE VIAJERO',
]);

const SIGLO_FIXED_PRODUCT_CATALOG = Object.freeze(
  SIGLO_PRODUCTS.flatMap(({ label, code }) => TX_ALL_METHODS.map((method) => `${label} (${code}) - ${method}`))
);

// Catálogo plano para la UI: reemplaza CREDITO por sus dos variantes visuales
const SIGLO_UI_PRODUCT_CATALOG = Object.freeze(
  SIGLO_UI_PRODUCTS.flatMap(({ label, code }) => TX_ALL_METHODS.map((method) => `${label} (${code}) - ${method}`))
);

function parseSigloProductName(combined) {
  if (!combined) return null;
  const s = String(combined).trim();
  const methodSep = s.lastIndexOf(' - ');
  if (methodSep === -1) return null;
  const method = s.slice(methodSep + 3).trim();
  const productPart = s.slice(0, methodSep).trim();
  const codeStart = productPart.lastIndexOf(' (');
  const codeEnd = productPart.lastIndexOf(')');
  if (codeStart === -1 || codeEnd === -1 || codeEnd < codeStart) return null;
  const rawLabel = productPart.slice(0, codeStart).trim();
  const code = productPart.slice(codeStart + 2, codeEnd).trim();
  // Registros anteriores guardados como "CREDITO" (sin variante) se mapean a "CREDITO SIMPLE"
  const label = rawLabel === 'CREDITO' ? 'CREDITO SIMPLE' : rawLabel;
  return { label, code, method };
}

function normalizeCreditVariant(combined) {
  if (!combined) return combined;
  return String(combined)
    .replace(/^CREDITO SIMPLE \(PLD/, 'CREDITO (PLD')
    .replace(/^CREDITO CUENTA CORRIENTE \(PLD/, 'CREDITO (PLD');
}

export default SIGLO_FIXED_PRODUCT_CATALOG;
export {
  SIGLO_PRODUCTS,
  SIGLO_UI_PRODUCTS,
  TX_ALL_METHODS,
  SIGLO_FIXED_PRODUCT_CATALOG,
  SIGLO_UI_PRODUCT_CATALOG,
  parseSigloProductName,
  normalizeCreditVariant,
};
